import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [];



// WEBPACK FOOTER //
// ./src/app/auth/auth.routes.ts